import React, { useState } from 'react'
import { LeadDetailsDto } from 'api/Leads/Types/LeadDetailsDto'
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal'
import { useApiClient } from 'utils/api/ApiClient'
import { LeadsApiClient } from 'utils/api/leadsApi'

import { LeadNavigation } from '../Navigation/LeadNavigation'
import { LeadActivitiesTable } from './LeadActivitiesTable'
import { LeadTab } from './LeadSlug'

interface Props {
  data: LeadDetailsDto
}

const LeadActivitiesPage: React.FC<Props> = ({ data }) => {
  const leadsApiClient = useApiClient(LeadsApiClient)

  const [isConfirmationActivityModalOpen, setConfirmationActivityModalOpen] =
    useState<boolean>(false)

  const handleResetActivity = async () => {
    await leadsApiClient.resetLeadActivity(data.id)
    setConfirmationActivityModalOpen(false)
  }

  const handleResetActivityModalOpen = () => {
    setConfirmationActivityModalOpen(true)
  }

  const handleResetActivityModalClose = () => {
    setConfirmationActivityModalOpen(false)
  }

  return (
    <React.Fragment>
      {isConfirmationActivityModalOpen && (
        <ConfirmationModal
          contentText='By resetting the Activity of the Lead, the client will have to start Client Area 1/2 Registration from the beginning. Please confirm you wish to continue.'
          yesButtonText='Yes'
          cancelButtonText='Cancel'
          onYes={handleResetActivity}
          onCancel={handleResetActivityModalClose}
          visible={isConfirmationActivityModalOpen}
        />
      )}
      <LeadNavigation data={data} isEdit={false} tab={LeadTab.ACTIVITIES} />
      <LeadActivitiesTable data={data} onResetActivity={handleResetActivityModalOpen} />
    </React.Fragment>
  )
}

export default LeadActivitiesPage
